import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {testIdProps} from '@github-ui/test-id-props'
import {LinkExternalIcon, RepoIcon} from '@primer/octicons-react'
import {FormControl, Link} from '@primer/react'

import {useAutomationGraph} from '../../../state-providers/workflows/use-automation-graph'
import {WorkflowResources} from '../../../strings'
import {useGetItemsAction} from '../hooks/use-get-items-action'
import {RepositoryPicker} from '../repository-picker'
import {SearchInput} from '../search-input'
import {AutomationBlock} from './automation-block'
import styles from './get-items-block.module.css'

interface GetItemsBlockProps {
  onNoSuggestedRepositories?: () => void
}
export const GetItemsBlock: React.FC<GetItemsBlockProps> = ({onNoSuggestedRepositories}) => {
  const {isEditing, localRepositoryId, localQuery, initialQuery} = useAutomationGraph()
  const {count, searchResultUrl, onRepositoryChange, onSearchQueryChange, repository} = useGetItemsAction()

  return (
    <AutomationBlock
      icon={RepoIcon}
      iconBg="var(--bgColor-severe-muted)"
      iconColor="attention.fg"
      headerDescription={WorkflowResources.getItemsBlockLabel}
      {...testIdProps('get-items-block')}
    >
      <FormControl className={styles.FormControl}>
        <FormControl.Label>Filters</FormControl.Label>
        <div className={styles.Box}>
          <RepositoryPicker
            targetRepositoryId={localRepositoryId}
            onRepositorySelected={onRepositoryChange}
            onNoSuggestedRepositories={onNoSuggestedRepositories}
            isEditing={isEditing}
            className={styles.RepositoryPicker}
            headerDescription={WorkflowResources.getItemsBlockLabel}
          />
          <div className={styles.Box_1}>
            {repository ? (
              <SearchInput
                onQueryChange={onSearchQueryChange}
                initialQuery={initialQuery}
                query={localQuery}
                repository={repository}
              />
            ) : (
              <LoadingSkeleton variant="rounded" height="32px" width="100%" />
            )}
          </div>
        </div>
        {isEditing && searchResultUrl && (
          <span className={styles.Text}>
            <Link
              target="_blank"
              rel="noreferrer"
              href={searchResultUrl}
              className={styles.RepositoryPicker}
              {...testIdProps('search-result-link')}
            >
              {' '}
              See {count} existing items that match this query <LinkExternalIcon />
            </Link>
            <div className={styles.Box_2}>
              {WorkflowResources.autoAddManualTip}{' '}
              <Link
                target="_blank"
                rel="noreferrer"
                href={
                  'https://docs.github.com/issues/planning-and-tracking-with-projects/managing-items-in-your-project/adding-items-to-your-project#adding-multiple-issues-or-pull-requests-from-a-repository'
                }
                {...testIdProps('add-multiple-link')}
                aria-label="Link to GitHub Docs page about adding multiple issues or pull requests to a project"
                className={styles.RepositoryPicker}
              >
                <LinkExternalIcon />
              </Link>
            </div>
          </span>
        )}
      </FormControl>
    </AutomationBlock>
  )
}
